module.exports = __webpack_public_path__ + "static/media/ninos-2.f408fb77.jpg";